<form (ngSubmit)="onSubmit()" *ngIf="form" [formGroup]="form">
  <div class="row mt-sm mx-none">
    <div class="col-12">
      <div class="col-12 col-lg-10">
        <well-person-inputs #personForm [person]="form.controls['personDTO'].value" data-testid="person-inputs-input"> </well-person-inputs>
      </div>

      <div class="col-12">
        <div class="col-12 col-lg-10 form-field mb">
          <p-floatlabel variant="on">
            <input
              formControlName="phoneNumber"
              id="phoneNumber"
              pInputText
              style="width: 100%"
              formInlineError="signup.firstContact.error"
              type="text" data-testid="phone-number-input"/>
            <label for="phoneNumber"
              >{{ 'signup.firstContact.inputs.phoneNumber' | translate }}
              {{ this.phoneNumberRequired && this.phoneNumberFormControl.validator ? ' *' : '' }}</label
            >
          </p-floatlabel>
        </div>

        <div class="pb">
          <div class="col-12 col-lg-10 form-field">
            <p-floatlabel variant="on">
              <input
                formControlName="email"
                id="email"
                pInputText
                style="width: 100%"
                formInlineError="signup.firstContact.error"
                type="text" data-testid="email-input"/>
              <label for="email"
                >{{ 'signup.firstContact.inputs.email' | translate }}
                <span>{{ this.emailRequired && this.emailFormControl.validator ? ' *' : '' }}</span></label
              >
            </p-floatlabel>
          </div>
        </div>

        <div class="pb">
          <div class="col-12 col-lg-10 form-field flex-row-forced align-items-center">
            <p-toggleswitch formControlName="receivesRequests" data-testid="receives-requests-toggle"></p-toggleswitch>
            <label class="ml-sm">{{ 'signup.firstContact.inputs.receivesRequests' | translate }}</label>
          </div>
        </div>

        <div class="pb">
          <div
            class="col-12 col-lg-10"
            pTooltip="{{ 'signup.firstContact.receivesRequestsRequiredTooltip' | translate }}"
            [tooltipDisabled]="receivesRequestsFormControl.value"
          >
            <p-floatlabel variant="on">
              <p-select
                [options]="contactMethods"
                [style]="{ width: '100%' }"
                appendTo="body"
                [autoDisplayFirst]="false"
                formInlineError="signup.firstContact.error"
                [disabled]="!receivesRequestsFormControl.value"
                formControlName="contactMethod"
                id="contactMethod" data-testid="contact-method-select">
              </p-select>
              <label for="contactMethod"
                >{{ 'signup.firstContact.inputs.contactMethod' | translate }}
                {{ this.contactMethodRequired && this.contactMethodFormControl.validator ? ' *' : '' }}</label
              >
            </p-floatlabel>
          </div>
        </div>

        <div class="d-flex pt col-12 col-lg-10 form-field">
          <p-floatlabel variant="on">
            <input formControlName="department" id="department" pInputText [style]="{ width: '100%' }" data-testid="department-input"/>
            <label for="department">{{ 'signup.firstContact.inputs.departmentName' | translate }}</label>
          </p-floatlabel>
        </div>

        <div class="col-12 col-lg-10">
          <div class="col-6 form-field mt pr-sm">
            <p-floatlabel variant="on">
              <p-datePicker
                [readonlyInput]="true"
                styleClass="col-12"
                formControlName="validFrom"
                dataType="string"
                id="validFrom"
                appendTo="body"
                dateFormat="yy-mm-dd"
                formInlineError="signup.firstContact.error" data-testid="valid-from-datepicker"></p-datePicker>
              <label for="validFrom">{{ 'signup.firstContact.inputs.validFrom' | translate }} (*)</label>
            </p-floatlabel>
          </div>
          <div class="col-6 form-field mt pl-sm">
            <p-floatlabel variant="on">
              <p-datePicker
                [readonlyInput]="true"
                styleClass="col-12"
                formControlName="validTo"
                dataType="string"
                id="validTo"
                appendTo="body"
                dateFormat="yy-mm-dd" data-testid="valid-to-datepicker"></p-datePicker>
              <label for="validTo">{{ 'signup.firstContact.inputs.validTo' | translate }}</label>
            </p-floatlabel>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex justify-end mt-5 mb-3 me-4">
    <button
      [style]="{ width: '130px' }"
      [label]="'signup.save' | translate"
      type="submit"
      pButton
      class="p-button-outlined save-button" data-testid="valid-to-btn"></button>
  </div>
</form>


